import { Component } from '@angular/core';

@Component({
  selector: 'pxl-root',
  standalone: false,
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {}
